"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { supabase } from "../lib/supabase";

/**
 * Handles Supabase auth tokens that arrive as URL fragments
 * Common with invitation flows where tokens end up as #access_token=...
 */
export function FragmentTokenHandler() {
  const router = useRouter();

  useEffect(() => {
    const handleFragmentTokens = async () => {
      if (typeof window === "undefined") return;

      const hash = window.location.hash;
      if (!hash.includes("access_token")) return;

      try {
        // The shared @supabase/ssr client processes fragments and writes
        // tokens to cookies automatically, so no manual sync is needed.
        const { data, error } = await supabase.auth.getSession();

        if (error) {
          console.error("Fragment token processing error:", error);
          return;
        }

        if (data.session?.user) {
          const user = data.session.user;
          const invitationId = user.user_metadata?.invitation_id;

          // Clear the fragment from URL
          window.history.replaceState(null, "", window.location.pathname);

          if (invitationId) {
            router.push(`/accept-invitation?invitation_id=${invitationId}`);
          } else {
            router.push("/a/inbox");
          }
        }
      } catch (error) {
        console.error("Fragment token handler error:", error);
      }
    };

    const timer = setTimeout(handleFragmentTokens, 200);
    return () => clearTimeout(timer);
  }, [router]);

  return null;
}
